import { STALE_TIME } from "#app/http/ReactQueryProvider";
import { fetchSurfaceTreatmentsPredictions } from "#modules/quoteRequestLines/infra/fetchSurfaceTreatmentsPredictions.api";
import { queryKeys } from "#shared/queryKeys/queryKeys";

export const surfaceTreatmentsPredictionsQuery = (quoteRequestLineId: string | undefined) => ({
  queryKey: queryKeys.surfaceTreatmentsPredictions.detail(quoteRequestLineId),
  queryFn: () => fetchSurfaceTreatmentsPredictions(quoteRequestLineId!),
  staleTime: STALE_TIME,
  enabled: !!quoteRequestLineId,
});
